'use strict';
import Price from './price';
import PriceSaleSection from './price/price-sale';
import ScheduleSection from './price/schedule';
export default class PriceSale extends Price {
    constructor() {
        super();
        this.Price = new PriceSaleSection();
        this.Schedule = new ScheduleSection();
    }
    init() {
        super.init();
    }
    setElement() {
        let form = document.createElement('div');
        form.classList.add('priceform');
        form.append(this.Price.getElement());
        form.append(this.Rounding.getElement());
        form.append(this.Schedule.getElement());
        this.element = form;
    }
    getValue() {
        return {
            price: this.Price.getValue(),
            rounding: this.Rounding.getValue(),
            schedule: this.Schedule.getValue()
        };
    }
    setValue(value) {
        super.setValue(value);
        if (value.schedule_from || value.schedule_to) {
            this.Schedule.setState(true).initState();
            this.Schedule.setFromDate(value.schedule_from);
            this.Schedule.setToDate(value.schedule_to);
        }
    }
    getElement() {
        return this.element;
    }
    show() {
        this.getElement().style.display = 'block';
    }
    hide() {
        this.getElement().style.display = 'none';
    }
}
